<template>
    <div class="plan-summary-card">
        <div class="summary-row">
            <div class="summary-header">
                <h3 class="plan-name">{{ plan.name }}</h3>
                <div class="plan-price-large">
                    {{ plan.price }}
                    <span class="currency">€ <small class="fs-05 text-muted">TTC</small></span>
                </div>
            </div>
            <div v-if="duration" class="header-right">
                <div class="duration-badge">
                    <font-awesome-icon icon="clock" class="mr-1" />
                    {{ duration }}
                </div>
            </div>
        </div>

        <div v-if="filteredFeatures && filteredFeatures.length" class="summary-accordions-section">
            <h4 class="summary-section-title">Garanties accordées</h4>
            <div class="v2-plan-accordion summary-accordions">
                <div v-for="(feature, idx) in filteredFeatures" :key="idx" class="v2-accordion-item"
                    :class="{ 'is-expanded': expandedFeatures.includes(idx) }">
                    <div class="v2-accordion-header" @click="toggleFeature(idx, $event)">
                        <span class="v2-accordion-title">{{ feature.title }}</span>
                        <i class="v2-chevron-icon"></i>
                    </div>
                    <div v-if="expandedFeatures.includes(idx)" class="v2-accordion-content" v-html="feature.content">
                    </div>
                </div>
            </div>
            <div class="summary-footer" v-if="termsUrl">
                <a class="information-link-plan" :href="termsUrl" target="_blank">
                    Consulter les conditions générales
                </a>
            </div>
        </div>

        <div v-if="vehicle && vehicle.length" class="summary-vehicle-section">
            <h4 class="summary-section-title">Mon véhicule</h4>
            <ul class="summary-vehicle-details">
                <li v-for="(detail, dIdx) in vehicle" :key="dIdx">
                    <font-awesome-icon prefix="fas" icon="check" class="check-icon" />
                    <span class="li-label">{{ detail.label }} :</span>
                    <span class="li-value">{{ detail.value }}</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: "SelectedPlanSummary",
    props: {
        plan: {
            type: Object,
            required: true,
            // Expects { name, price, key }
        },
        duration: {
            type: String,
            default: ""
        },
        features: {
            type: Array,
            default: () => []
            // Expects [{ title, content }]
        },
        vehicle: {
            type: Array,
            default: () => []
            // Expects [{ label, value }]
        },
        termsUrl: {
            type: String,
            default: ""
        }
    },
    computed: {
        filteredFeatures() {
            if (!this.features) return [];
            return this.features.filter(f => f.title.toLowerCase() !== 'important' && f.title.toLowerCase() !== 'import');
        }
    },
    data() {
        return {
            expandedFeatures: []
        };
    },
    methods: {
        toggleFeature(index, event) {
            const pos = this.expandedFeatures.indexOf(index);
            const isExpanding = pos === -1;

            if (!isExpanding) {
                this.expandedFeatures.splice(pos, 1);
            } else {
                this.expandedFeatures.push(index);

                // Auto-scroll logic to show content
                if (event && event.currentTarget) {
                    const header = event.currentTarget;
                    this.$nextTick(() => {
                        const container = this.$el.querySelector('.summary-accordions');
                        const item = header.closest('.v2-accordion-item');

                        if (container && item) {
                            // Calculate the scroll position needed to show the content
                            // We use a small delay to ensure the expansion animation/layout is ready
                            setTimeout(() => {
                                const containerRect = container.getBoundingClientRect();
                                const itemRect = item.getBoundingClientRect();

                                // If the item's bottom is outside the viewport of the container, scroll it
                                if (itemRect.bottom > containerRect.bottom) {
                                    const scrollNeeded = itemRect.bottom - containerRect.bottom;
                                    container.scrollBy({
                                        top: scrollNeeded + 20, // Add some padding
                                        behavior: 'smooth'
                                    });
                                }
                            }, 50);
                        }
                    });
                }
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/Garantie/shared/SelectedPlanSummary.vue